import { render, staticRenderFns } from "./assistantAiList.vue?vue&type=template&id=97163c26&scoped=true"
import script from "./assistantAiList.vue?vue&type=script&lang=js"
export * from "./assistantAiList.vue?vue&type=script&lang=js"
import style0 from "./assistantAiList.vue?vue&type=style&index=0&id=97163c26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97163c26",
  null
  
)

export default component.exports